import type { Editor } from '@tiptap/react';
import { useUIStore } from '@/stores/use-ui-store';
import { selectionToCaptureMarkdown } from './markdown-copy';

interface GenerateFromSelectionRequest {
  entityId: string;
  fragmentName: string;
  templateId: string | null;
}

export function requestGenerateFromSelection(
  editor: Editor,
  { entityId, fragmentName, templateId }: GenerateFromSelectionRequest,
): boolean {
  const markdown = selectionToCaptureMarkdown(editor);
  if (markdown === null || markdown.trim() === '') return false;
  useUIStore.getState().requestFromSelection(entityId, { fragmentName, markdown, templateId });
  return true;
}
